import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../shared/services/http-request.service';
import * as myGlobals from '../shared/globalcontants';
import { APIServiceProviderService } from '../shared/services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { of as observableOf, Observable } from 'rxjs';
import { InventoryEntity } from '../shared/models/Inventory/InventoryEntity';
import { SearchHistoryEntity } from '../shared/models/Transactions/SearchHistoryEntity';
import { InventoryCollectionType, InventoryLinkTypes, TransactionType } from '../shared/globalcontants';
import { InventoryCollectionEntity } from '../shared/models/Inventory/InventoryCollectionEntity';
import { LinkedItemEntity } from '../shared/models/LinkedItems/LinkedItemEntity';
import { RequisitionEntity } from '../shared/models/Transactions/RequisitionEntity';
import { FormGroup } from '@angular/forms';
import { RequisitionHeadEntity } from '../shared/models/Transactions/RequisitionHeadEntity';

@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  transactionCount = 0;
  priorityList: any = ['Primary', 'Secondary', 'Last Resort'];
  reqStatusList: any = ['Approved', 'Denied'];
  public selectedItem: any;
  public newReqData: any = [];
  public savedRequisitionTableData: any = [];
  public isPackage = false;
  public isCopyNew = false;
  public isLoadSaved = false;
  public selectedPackageItems: any = [];
  public requisitionEntity: RequisitionEntity = null;
  public baseUnits = ['Pounds', 'Kgs', 'Ltr'];
  public reqrouteStack: any = ['/inventory/requisition'];
  public reqID: Number;
  private _Is: InventoryService;
  public isNewRequisition = false;
  public requisitionFormData: FormGroup;
  public offlineIconShow = false;
  public requisitionFilter: any = [];
  public genericReqFilter: any = [];
  public newRequisitionFilter: any = [];
  public requisitionOfflineFilter: any = [];
  public backOrderData: any = [];
  public requisitionSort: any;
  public GenericrequisitionSort: any;
  public defaultSelect: any;
  InventotyLookupData: Array<any> = []
  constructor(private http: HttpClient, private _hs: HttpRequestService, private apiServiceProviderService: APIServiceProviderService) { }

  getInventoryDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }
  getTransactionDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }
  getInventoryDetail(transType: number, siteId: number, itemId: number[], apiKey: string, toLocation?: number,
    supplyLocation?: number): Observable<InventoryEntity[]> {
    // tslint:disable-next-line: max-line-length
    return this.apiServiceProviderService.inventoryService.GetInventoryDetails(transType, siteId, itemId, apiKey,  toLocation, supplyLocation);
  }
  getInventoryLocationDetail(siteId: number, itemId: number[], loadFrom: number): Observable<InventoryEntity[]> {
    return this.apiServiceProviderService.inventoryService.GetInventoryStatusByLocation(siteId, itemId, loadFrom);
  }
  getInventorySupplierDetail(itemId: number): Observable<InventoryEntity[]> {
    return this.apiServiceProviderService.inventoryService.GetInventoryBidDetails(itemId);
  }
  getOptionArray() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['inventoryList']);
  }
  getInventoryCollectionDetails(collectionType: InventoryCollectionType, siteId: number,
    typeId: number[], supplyLocationId: number): Observable<InventoryCollectionEntity[]> {
    return this.apiServiceProviderService.inventoryService.GetInventoryCollectionDetails(collectionType,
      siteId, typeId, supplyLocationId);
  }
  getPackageItem() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson.packageListItems);
  }
  getSearchSource(): Observable<SearchHistoryEntity[]> {
    return this.apiServiceProviderService.transactionService.GetSearchSource();
  }
  /**
   * @function getRecentreacheditem(jsonPath);
   * @prams String
   * @description get the recently item list from tha local josn
   * @output Array<object>
   */
  getRecentreacheditem(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }
  getSearchHistory(userId: number, sourceId: number): Observable<SearchHistoryEntity[]> {
    return this.apiServiceProviderService.transactionService.GetSearchHistory(userId, sourceId);
  }
  getLinkedItems(inventoryLinkTypes: InventoryLinkTypes, siteId: number, itemId: number): Observable<LinkedItemEntity> {
    return this.apiServiceProviderService.inventoryService.GetInventoryLinkItems(inventoryLinkTypes, siteId, itemId);
  }
  getBarcodeItems() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson.barCode);
  }
}
